// ===========================================================================
// THE NOTICE RULE — client mirror (operator 2026-10-12).
//
// "Finance created a payment received without anyone submitting order /
// submitting payment slip … it shall create a pending task to all sales/finance
// … once it's claimed by sales/finance, it goes back to similar task procedure."
//
// A credit nobody has accounted for carries ONE notice (a pr_notification task).
// Whoever claims the notice owns the credit's next step: every other user is
// refused (409 NOTICE_CLAIMED) when they try to link it to an order, link it to
// a platform sell, assign it to a customer, classify it, mark it as a swap or
// mark it as dust. Acting on an UNCLAIMED notice claims it for you in the same
// step.
//
// THE SERVER IS THE AUTHORITY (noticeClaimBlock / takeNoticesForActionInTxn in
// backend/server.js). Every credit row a screen lists (Create Order, Order
// History edit, Assign Transactions, the platform sell picker, Submit Payment
// Received, Transaction History, Money Available) carries three fields the
// server projects from the notice itself:
//   notice_task_id          — the notice (null: the credit has none open)
//   notice_claimed_by       — who holds it (null: nobody)
//   notice_claimed_by_name  — their username
// These helpers only READ them, so every screen locks exactly the rows the
// server would refuse, and names the same person.
// ===========================================================================

export const noticeHeld = (row) => !!row && row.notice_claimed_by != null;

export const noticeHeldByMe = (row, user) =>
  noticeHeld(row) && !!user && Number(row.notice_claimed_by) === Number(user.id);

// The lock: someone ELSE holds this credit's notice.
export const noticeHeldByOther = (row, user) => noticeHeld(row) && !noticeHeldByMe(row, user);

export const noticeHolderName = (row) => (row && row.notice_claimed_by_name) || 'another user';

// Short label for a chip / disabled row.
export const noticeChipLabel = (row, user) => {
  if (!noticeHeld(row)) return null;
  return noticeHeldByMe(row, user) ? 'Claimed by you' : `Claimed by ${noticeHolderName(row)}`;
};

// The tooltip / inline reason on a locked row.
export const noticeLockedReason = (row) =>
  `${noticeHolderName(row)} has claimed this payment${row && row.notice_task_id ? ` (notice #${row.notice_task_id})` : ''}. ` +
  'Only they can link, assign, classify or swap it until they release it in Task Tracking.';

// Was this API error the server's notice rule?
export const isNoticeClaimedError = (err) =>
  !!err && !!err.response && err.response.status === 409 &&
  !!err.response.data && err.response.data.code === 'NOTICE_CLAIMED';
